<template>
  <div class="h-full">
    <div class="sidebar-layout__toolbar">
      <v-datepicker position-left v-model="date"></v-datepicker>
    </div>
    <planning-tabs />
    <template v-if="!isMobile">
      <leftovers-list v-if="loaded" :loaded="loaded" :leftovers="leftovers"></leftovers-list>
      <list-item-skeleton v-else></list-item-skeleton>
    </template>
    <template v-else>
      <leftovers-mobile v-if="loaded" :loaded="loaded" :leftovers="leftovers" />
      <list-item-skeleton v-else></list-item-skeleton>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import PlanningTabs from '../common/PlanningTabs'
import LeftoversList from './list/LeftoversList'
import LeftoversMobile from './mobile/LeftoversMobile'
import ListItemSkeleton from './list/ListItemSkeleton'
import { getDateForDatePicker } from '@/util'

export default {
  name: 'Leftovers',
  components: {
    PlanningTabs,
    LeftoversList,
    LeftoversMobile,
    ListItemSkeleton
  },
  mixins: [adaptationMixin],
  mounted () {
    this.date = getDateForDatePicker(this.timezone)
    this.updateURL()
    this.init()
  },
  data () {
    return {
      date: null,
      loaded: false,
      leftovers: [],
      isLoading: false,
      loadTimeout: null, // For debouncing
    }
  },
  computed: {
    yesterdayDate () {
      if (!this.date) return null

      const [year, month, day] = this.date.split('-').map(Number)
      const yesterday = new Date(Date.UTC(year, month - 1, day - 1))
      return yesterday.toISOString().substring(0, 10)
    },
    farmId () {
      return this.$route.params.farm_id
    },
    timezone () {
      return this.$store.getters['account/timezone']
    },
  },
  methods: {
    async init () {
      if (this.isLoading) return

      // Clear any pending debounced calls
      if (this.loadTimeout) {
        clearTimeout(this.loadTimeout)
      }

      // Debounce the loading to prevent rapid successive calls
      this.loadTimeout = setTimeout(async () => {
        await this.loadLeftovers()
        this.loaded = true
      }, 100)
    },
    updateURL () {
      const query = { ...this.$route.query, date: this.date }
      this.$router.replace({ query })
    },
    async loadLeftovers () {
      if (this.isLoading || !this.yesterdayDate) return

      this.isLoading = true

      const clientId = this.$store.getters.clientId

      const params = {
        farm: this.$route.params.farm_id,
        date_leftover: this.yesterdayDate,
      }

      try {
        let result

        if (this.isAdmin || this.isStaff || this.isConsultant) {
          result = await api.dashboard.clients.getLeftoversById(clientId, params)
        } else {
          result = await api.leftovers.list(params)
        }

        const { data, errors } = result

        if (!errors) {
          this.leftovers = data
        } else {
          console.error('wrong data')
        }
      } finally {
        this.isLoading = false
      }
    },
  },
  watch: {
    timezone (newTimezone) {
      this.date = getDateForDatePicker(newTimezone)
    },
    date (newDate, oldDate) {
      if (newDate && newDate !== oldDate) {
        this.updateURL()
        this.init()
      }
    }
  },
}
</script>